import { render, staticRenderFns } from "./FrameProfile.vue?vue&type=template&id=66f4826e&scoped=true&"
import script from "./FrameProfile.vue?vue&type=script&lang=js&"
export * from "./FrameProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f4826e",
  null
  
)

export default component.exports